import napStyles from './../nap.json'

export default {
  paginatorPosition: 'top',
  paginatorColor: napStyles.colors.PrimaryWhite,
  paginatorBottomSpacing: 16,
  paginatorTopSpacing: 0
}
